import { renderPhase2DashboardPulse } from '../components/charts/Phase2DashboardPulse';
import { renderMarketRadar } from '../components/MarketRadar';
import { isFeatureEnabled } from '../services/runtime-config';
import { navigate } from '../router/router';

export function renderSessionRadar(): string {
  return `
    <section class="radar-page">
      <header class="radar-page__hero">
        <div>
          <p class="radar-page__eyebrow">Dedicated Pulse Board</p>
          <h1 class="radar-page__title">Session Radar</h1>
          <p class="radar-page__subtitle">A separate workspace for breadth, volatility, dispersion, and live pulse structure without crowding the dashboard overview.</p>
        </div>
        <div class="radar-page__actions">
          <button type="button" class="radar-page__action" data-path="/">Back to Overview</button>
          <button type="button" class="radar-page__action" data-path="/markets">Open Markets</button>
        </div>
      </header>

      <div id="session-radar-root" class="radar-page__body"></div>
    </section>
  `;
}

export function initSessionRadar(): void {
  const container = document.getElementById('session-radar-root');
  if (container) {
    if (isFeatureEnabled('charts_v2_engine')) {
      renderPhase2DashboardPulse(container);
    } else {
      renderMarketRadar(container);
    }
  }

  document.querySelectorAll('.radar-page__action').forEach((button) => {
    button.addEventListener('click', () => {
      const path = button.getAttribute('data-path');
      if (path) navigate(path);
    });
  });
}
